module.exports = "<!-- <div class=\"container-fluid\" style=\"margin: 10px auto -30px auto;\" >\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div *ngFor=\"let message of messages\" [ngClass]=\"{ 'alert': message?.value, 'alert-success': message?.value?.type === 'success', 'alert-danger': message?.value?.type === 'error' }\">{{ message?.value?.text }}</div>\n    </div>\n  </div>\n</div> -->\n\n<p-growl [(value)]=\"msgs\"></p-growl>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/alert/alert.component.html
// module id = ../../../../../src/app/shared/widgets/alert/alert.component.html
// module chunks = main